import React from 'react'

function Footer() {

  return (
    <>
        <footer className='bottom-0 flex justify-center p-2 text-xs font-light md:font-medium md:text-sm fixed bg-white w-full border-t-2 border-gray-300'>
            © {(new Date().getFullYear())} - FodderLink - Privacy
        </footer>
    </>
  )
}

export default Footer